import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hero-image-text',
  templateUrl: './hero-image-text.component.html',
  styleUrls: ['./hero-image-text.component.css'],
})
export class HeroImageTextComponent {
  @Input() data!: any;
}
